/* eslint-disable no-undef */
/*
  Helpers for using iframe
*/

const getFrame = () => {
  let frame = document.getElementById('mainframe');
  return frame;
};

export const getFrameWindow = () => {
  const frame = getFrame();
  return frame != null ? frame.contentWindow : window;
};

export const getFrameDocument = () => getFrameWindow().document;

export const getElementFromFrame = id => getFrameWindow().document.getElementById(id);

// MAV controllers return redirects which are used to update JSP iframe
export const redirectIFrame = url => {
  const frame = getFrame();
  if (frame) {
    frame.src = url;
  }
  else {
    window.location.replace(url);
  }
};

/* Support loading of the library without iframe (eg. Print view) */
export const isInIFrame = () => {
  // mainframe == iframe in DAM (JSP templating) 
  const iframe = document.getElementById('mainframe');
  return !iframe;
};

export const setFrame = contents => getFrame().srcdoc = contents;